import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AttentionMessage } from '@eika/attention-message';
import { Link, LinkType } from '@eika/link';

import { Header } from '../../components/header/header';
import { RadioButtons } from '../../components/radio-buttons/radio-buttons';
import SporreskjemaButton from '../../components/sporreskjema-button/sporreskjema-button';
import { StepNavigation } from '../../components/step-navigation/step-navigation';
import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useBankregnr, useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { toOptions } from '../../sporsmalsflyt/radio/radio';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { navigateToSitecorePage } from '../../urler';
import { SideType } from '../../utils/piwik-utils';
import { getEttersendingUrl } from '../deep-link-handler';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.DyrHund,
        tekst: 'Hund',
    },
    {
        id: KategoriSvarId.DyrKatt,
        tekst: 'Katt',
    },
    {
        id: KategoriSvarId.DyrHest,
        tekst: 'Hest',
    },
];

export const Dyr = () => {
    const navigate = useNavigate();
    const { links } = useConfig();

    const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined);

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.DyrHund) {
            navigate(urler().hundUrl);
        } else if (svarId === KategoriSvarId.DyrKatt) {
            navigate(urler().kattUrl);
        } else if (svarId === KategoriSvarId.DyrHest) {
            navigate(urler().hestUrl);
        }
    };

    const bankregnr = useBankregnr();

    const goback = () => navigateToSitecorePage(links.dyrlandingsside.url);

    return (
        <>
            <form className="meld-skade-form">
                <Header svgCardType={SvgCardType.DyrHund} title="Hund, katt og hest" subtitle="Skademelding" />
                <div className="container__standard-width ettersending-card">
                    <AttentionMessage
                        id="attention-ettersending"
                        text={
                            <>
                                <h3 className="typography-subtitle">Har du nye utgifter på tidligere meldt skade?</h3>
                                <p>
                                    Her kan du sende inn tilleggsinformasjon eller nye utgifter som tilhører en sak du
                                    allerede har meldt inn til oss. Dette gjelder også hvis saken står som avsluttet.
                                </p>
                            </>
                        }
                        type="info"
                        clickableItem={
                            <Link href={getEttersendingUrl()} linkType={LinkType.BUTTON_STANDARD_NEGATIVE}>
                                Oppdater saken din
                            </Link>
                        }
                    />
                </div>
                <RadioButtons
                    name=""
                    label="Hvilket dyr vil du melde skade på?"
                    options={toOptions(alternativer)}
                    selectedOption={selectedOption}
                    onChange={setSelectedOption}
                    focusOnMount
                />
                <StepNavigation
                    bankregnr={bankregnr}
                    next={{
                        onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                            e.preventDefault();
                            onNext(selectedOption);
                        },
                        disabled: !selectedOption,
                    }}
                    prev={{
                        onClick: goback,
                    }}
                    sideDetail={{ type: SideType.Kategoriside, kategoriId: 'dyr' }}
                />
            </form>
            <SporreskjemaButton />
        </>
    );
};
